import { u as a } from "./useStateManager-7e1e8489.esm.js";
import { u as x } from "./useStateManager-7e1e8489.esm.js";
import { forwardRef as o } from "react";
import { S as f } from "./Select-457c486b.esm.js";
import { c as M, d as v } from "./Select-457c486b.esm.js";
import "react-dom";
import { jsx as m } from "../../../_virtual/jsx-runtime.js";
var s = /* @__PURE__ */ o(function(e, r) {
  var t = a(e);
  return /* @__PURE__ */ m(f, {
    ref: r,
    ...t
  });
});
const l = s;
export {
  M as createFilter,
  l as default,
  v as defaultTheme,
  x as useStateManager
};
//# sourceMappingURL=react-select.esm.js.map
